export default __webpack_public_path__ + "static/1996-06-01_auditory_MP.pdf";